const cpfCnpjFormater = (cpfCnpj: string) => {
    if (!cpfCnpj) return "";

    const formatted =
        cpfCnpj.length > 11 ?
            cpfCnpj.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5") :
            cpfCnpj.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4")

    return formatted;
};

export { cpfCnpjFormater };
